import { Component, Input } from '@angular/core';

export interface PasswordRequirement {
  name: string;
  validator: (password: string) => boolean;
}

@Component({
  selector: 'app-password-strength',
  templateUrl: './password-strength.component.html',
  styleUrls: ['./password-strength.component.scss']
})
export class PasswordStrengthComponent {
  @Input() password = '';
  requirements: PasswordRequirement[] = [
    {
      name: 'Lowercase & Uppercase',
      validator: (pwd) => /(?=.*[a-z])(?=.*[A-Z])/.test(pwd)
    },
    {
      name: 'Number (0-9)',
      validator: (pwd) => /(?=.*\d)/.test(pwd)
    },
    {
      name: 'Special Character (!@#$)',
      validator: (pwd) => /(?=.*[!@#$%^&*])/.test(pwd)
    },
    {
      name: 'At least 8 Characters long',
      validator: (pwd) => pwd.length >= 8
    }
  ];

  isRequirementMet(index: number): boolean {
    const password = this.password || '';
    return this.requirements[index]?.validator(password) ?? false;
  }

  getRequirementsMet(): number {
    const password = this.password || '';
    return this.requirements.filter((req) => req.validator(password)).length;
  }

  getProgressPercentage(): number {
    if (!this.requirements.length) {
      return 0;
    }

    return (this.getRequirementsMet() / this.requirements.length) * 100;
  }
}
